import * as React from 'react';
import { SVGProps } from 'react';

const SvgSocialSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M4.934 35.176H3.132V30.94a8.113 8.113 0 0 1 8.106-8.106h1.802a8.114 8.114 0 0 1 8.105 8.106v4.208h-1.8V30.94a6.311 6.311 0 0 0-6.305-6.304h-1.802a6.312 6.312 0 0 0-6.304 6.304v4.237Z"
    />
    <path
      fill={props.fill}
      d="M37.437 35.147v3.585l-30.738.018-3.574-3.57 34.312-.033Z"
    />
    <path
      fill="currentColor"
      d="M12.139 24.613a5.52 5.52 0 0 1-5.512-5.515V16.32h1.801v2.777a3.718 3.718 0 0 0 6.34 2.628 3.719 3.719 0 0 0 1.092-2.628V16.32h1.802v2.777a5.518 5.518 0 0 1-5.523 5.516Z"
    />
    <path
      fill="currentColor"
      d="M17.662 19.09H15.86v-2.78a3.715 3.715 0 0 0-3.71-3.712 3.714 3.714 0 0 0-3.711 3.711v2.781H6.638v-2.78a5.516 5.516 0 0 1 5.512-5.513 5.516 5.516 0 0 1 5.512 5.512v2.781Zm19.731 16.061h-1.8v-.49a6.312 6.312 0 0 0-6.306-6.305h-1.8a6.312 6.312 0 0 0-6.305 6.305v.486H19.38v-.486a8.117 8.117 0 0 1 8.106-8.106h1.801a8.116 8.116 0 0 1 8.106 8.106v.49Z"
    />
    <path
      fill="currentColor"
      d="M28.387 28.335a5.52 5.52 0 0 1-5.512-5.512V20.04h1.801v2.782a3.714 3.714 0 0 0 6.336 2.624 3.714 3.714 0 0 0 1.089-2.624V20.04h1.801v2.782a5.52 5.52 0 0 1-5.515 5.512Z"
    />
    <path
      fill="currentColor"
      d="M33.902 22.812h-1.801v-2.778a3.718 3.718 0 0 0-3.714-3.714 3.718 3.718 0 0 0-3.711 3.714v2.778h-1.801v-2.778a5.523 5.523 0 0 1 5.512-5.515 5.522 5.522 0 0 1 5.515 5.515v2.778ZM20.926 13.86c-.216 0-.427-.062-.61-.177a1.139 1.139 0 0 1-.525-1.21l.021-.084.807-2.687a4.662 4.662 0 0 1-1.08-2.944c0-3.4 2.673-5.508 6.97-5.508 3.841 0 6.968 2.468 6.968 5.508 0 3.041-3.127 5.505-6.967 5.505a11.925 11.925 0 0 1-1.413-.122l-3.602 1.56c-.173.1-.37.155-.57.158Zm5.59-10.809c-3.241 0-5.169 1.384-5.169 3.707.02.795.35 1.55.922 2.1l.36.38-.695 2.308 2.911-1.26.256.04c.466.07.935.116 1.405.136 2.85 0 5.166-1.66 5.166-3.704 0-2.042-2.305-3.707-5.155-3.707Z"
    />
  </svg>
);

export default SvgSocialSupport;
